import { createAccountSession } from "./AccountSession.ts";
import { browserAccountSessionStorage } from "./browserAccountSessionStorage.ts";

export const accountSession = createAccountSession({
	backend: {
		startDiscordSignIn: async () => {
			const { httpAccountSessionBackend } = await import("./httpAccountSessionBackend.ts");
			return httpAccountSessionBackend.startDiscordSignIn();
		},
		exchangeDiscordCode: async (callback) => {
			const { httpAccountSessionBackend } = await import("./httpAccountSessionBackend.ts");
			return httpAccountSessionBackend.exchangeDiscordCode(callback);
		},
			loadAccount: async () => {
				const { httpAccountSessionBackend } = await import("./httpAccountSessionBackend.ts");
				return httpAccountSessionBackend.loadAccount();
			},
			logout: async () => {
				const { httpAccountSessionBackend } = await import("./httpAccountSessionBackend.ts");
				return httpAccountSessionBackend.logout();
			},
	},
	persistence: browserAccountSessionStorage,
});
